import script from "./AuraComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraComposer.vue?vue&type=script&setup=true&lang=ts"

import "./AuraComposer.vue?vue&type=style&index=0&id=0c4cbd4f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4cbd4f"]])

export default __exports__